
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/swp",
      function () {
        return require("private-next-pages/calculators/swp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/swp"])
      });
    }
  